<div class="container-fluid d-flex justify-content-between" >
    <div class="body-font-size col-lg-6 d-flex justify-content-start">
        <p class="footer-para">© {{date}} Aithent Inc. All Rights Reserved.</p>
    </div>
    <div class="body-font-size col-lg-6 d-flex justify-content-end">
        <p class="footer-para">Version {{version}}</p>
    </div>
</div>